/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationEventPccPatient } from './IntegrationEventPccPatient';
import {
    IntegrationEventPccPatientFromJSON,
    IntegrationEventPccPatientFromJSONTyped,
    IntegrationEventPccPatientToJSON,
    IntegrationEventPccPatientToJSONTyped,
} from './IntegrationEventPccPatient';
import type { AdmissionDetails } from './AdmissionDetails';
import {
    AdmissionDetailsFromJSON,
    AdmissionDetailsFromJSONTyped,
    AdmissionDetailsToJSON,
    AdmissionDetailsToJSONTyped,
} from './AdmissionDetails';
import type { PccAdmissionRecord } from './PccAdmissionRecord';
import {
    PccAdmissionRecordFromJSON,
    PccAdmissionRecordFromJSONTyped,
    PccAdmissionRecordToJSON,
    PccAdmissionRecordToJSONTyped,
} from './PccAdmissionRecord';
import type { IntegrationEventTooltips } from './IntegrationEventTooltips';
import {
    IntegrationEventTooltipsFromJSON,
    IntegrationEventTooltipsFromJSONTyped,
    IntegrationEventTooltipsToJSON,
    IntegrationEventTooltipsToJSONTyped,
} from './IntegrationEventTooltips';

/**
 * 
 * @export
 * @interface IntegrationEvent
 */
export interface IntegrationEvent {
    /**
     * 
     */
    id?: number;
    /**
     * 
     */
    facility_id?: number;
    /**
     * 
     */
    integration_patient_id?: string;
    /**
     * 
     */
    actioned?: boolean;
    /**
     * 
     */
    state?: string;
    /**
     * 
     */
    integration?: string;
    /**
     * 
     */
    event_type?: string;
    /**
     * 
     */
    event_payload?: object;
    /**
     * 
     */
    fetched_data?: object;
    /**
     * 
     */
    auto_applied?: boolean;
    /**
     * 
     */
    actioned_by_user_id?: number;
    /**
     * 
     */
    action_source?: IntegrationEventActionSourceEnum;
    /**
     * 
     */
    actioned_by_name?: string | null;
    /**
     * 
     */
    actioned_at?: string;
    /**
     * 
     * @deprecated
     */
    processor_outcome_reason?: string;
    /**
     * 
     */
    processor_outcome?: IntegrationEventProcessorOutcomeEnum;
    /**
     * 
     */
    display_outcome_reason?: string;
    /**
     * Per-event leave classification for leave and return-from-leave events, null for other event types. With leave event classification enabled, leaves use their Action Type; pending returns use the lead's LOA or Hospitalized status, else their own Action Type. Otherwise matches the facility leave_admission_status.
     */
    leave_admission_status?: IntegrationEventLeaveAdmissionStatusEnum | null;
    /**
     * 
     */
    createdAt?: string;
    /**
     * 
     */
    updatedAt?: string;
    /**
     * 
     */
    tooltips?: IntegrationEventTooltips;
    /**
     * 
     */
    pcc_patient?: IntegrationEventPccPatient;
    /**
     * 
     */
    current_admission_details?: AdmissionDetails | null;
    /**
     * 
     */
    actioned_admission_details?: AdmissionDetails | null;
    /**
     * 
     */
    integration_admission_status?: PccAdmissionRecord | null;
}


/**
 * @export
 */
export const IntegrationEventActionSourceEnum = {
    Manual: 'manual',
    Automatic: 'automatic',
} as const;
export type IntegrationEventActionSourceEnum = typeof IntegrationEventActionSourceEnum[keyof typeof IntegrationEventActionSourceEnum];

/**
 * @export
 */
export const IntegrationEventProcessorOutcomeEnum = {
    Applied: 'applied',
    NoOp: 'no_op',
    NeedsReview: 'needs_review',
    Stale: 'stale',
    Failed: 'failed',
    Postponed: 'postponed',
    AwaitingEarlierEvent: 'awaiting_earlier_event',
    CancelQueued: 'cancel_queued',
} as const;
export type IntegrationEventProcessorOutcomeEnum = typeof IntegrationEventProcessorOutcomeEnum[keyof typeof IntegrationEventProcessorOutcomeEnum];

/**
 * @export
 */
export const IntegrationEventLeaveAdmissionStatusEnum = {
    Loa: 'loa',
    Hospitalized: 'hospitalized',
} as const;
export type IntegrationEventLeaveAdmissionStatusEnum = typeof IntegrationEventLeaveAdmissionStatusEnum[keyof typeof IntegrationEventLeaveAdmissionStatusEnum];


/**
 * Check if a given object implements the IntegrationEvent interface.
 */
export function instanceOfIntegrationEvent(value: object): value is IntegrationEvent {
    return true;
}

export function IntegrationEventFromJSON(json: any): IntegrationEvent {
    return IntegrationEventFromJSONTyped(json, false);
}

export function IntegrationEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'integration_patient_id': json['integration_patient_id'] == null ? undefined : json['integration_patient_id'],
        'actioned': json['actioned'] == null ? undefined : json['actioned'],
        'state': json['state'] == null ? undefined : json['state'],
        'integration': json['integration'] == null ? undefined : json['integration'],
        'event_type': json['event_type'] == null ? undefined : json['event_type'],
        'event_payload': json['event_payload'] == null ? undefined : json['event_payload'],
        'fetched_data': json['fetched_data'] == null ? undefined : json['fetched_data'],
        'auto_applied': json['auto_applied'] == null ? undefined : json['auto_applied'],
        'actioned_by_user_id': json['actioned_by_user_id'] == null ? undefined : json['actioned_by_user_id'],
        'action_source': json['action_source'] == null ? undefined : json['action_source'],
        'actioned_by_name': json['actioned_by_name'] === undefined ? undefined : json['actioned_by_name'] === null ? null : json['actioned_by_name'],
        'actioned_at': json['actioned_at'] == null ? undefined : json['actioned_at'],
        'processor_outcome_reason': json['processor_outcome_reason'] == null ? undefined : json['processor_outcome_reason'],
        'processor_outcome': json['processor_outcome'] == null ? undefined : json['processor_outcome'],
        'display_outcome_reason': json['display_outcome_reason'] == null ? undefined : json['display_outcome_reason'],
        'leave_admission_status': json['leave_admission_status'] === undefined ? undefined : json['leave_admission_status'] === null ? null : json['leave_admission_status'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
        'tooltips': json['tooltips'] == null ? undefined : IntegrationEventTooltipsFromJSON(json['tooltips']),
        'pcc_patient': json['pcc_patient'] == null ? undefined : IntegrationEventPccPatientFromJSON(json['pcc_patient']),
        'current_admission_details': json['current_admission_details'] === undefined ? undefined : json['current_admission_details'] === null ? null : AdmissionDetailsFromJSON(json['current_admission_details']),
        'actioned_admission_details': json['actioned_admission_details'] === undefined ? undefined : json['actioned_admission_details'] === null ? null : AdmissionDetailsFromJSON(json['actioned_admission_details']),
        'integration_admission_status': json['integration_admission_status'] === undefined ? undefined : json['integration_admission_status'] === null ? null : PccAdmissionRecordFromJSON(json['integration_admission_status']),
    };
}

export function IntegrationEventToJSON(json: any): IntegrationEvent {
    return IntegrationEventToJSONTyped(json, false);
}

export function IntegrationEventToJSONTyped(value?: IntegrationEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'integration_patient_id': value['integration_patient_id'],
        'actioned': value['actioned'],
        'state': value['state'],
        'integration': value['integration'],
        'event_type': value['event_type'],
        'event_payload': value['event_payload'],
        'fetched_data': value['fetched_data'],
        'auto_applied': value['auto_applied'],
        'actioned_by_user_id': value['actioned_by_user_id'],
        'action_source': value['action_source'],
        'actioned_by_name': value['actioned_by_name'],
        'actioned_at': value['actioned_at'],
        'processor_outcome_reason': value['processor_outcome_reason'],
        'processor_outcome': value['processor_outcome'],
        'display_outcome_reason': value['display_outcome_reason'],
        'leave_admission_status': value['leave_admission_status'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'tooltips': IntegrationEventTooltipsToJSON(value['tooltips']),
        'pcc_patient': IntegrationEventPccPatientToJSON(value['pcc_patient']),
        'current_admission_details': AdmissionDetailsToJSON(value['current_admission_details']),
        'actioned_admission_details': AdmissionDetailsToJSON(value['actioned_admission_details']),
        'integration_admission_status': PccAdmissionRecordToJSON(value['integration_admission_status']),
    };
}

